import { LandedCostSettingsSchema } from "@redotech/redo-model/landed-cost/landed-cost-settings";
import * as z from "zod";

export const updateLandedCostSettings = {
  name: "updateLandedCostSettings" as const,
  input: z.object({
    teamId: z.string(),
    landedCost: LandedCostSettingsSchema,
    // Name of the logged-in admin enabling LCG, used as the Zonos vendor
    // child-org contact (accountUser) so it reflects the operator rather than
    // the brand name. The contact email is taken from the authenticated server
    // context, not from here. Optional so older clients don't fail validation.
    adminUser: z
      .object({ firstName: z.string(), lastName: z.string() })
      .optional(),
  }),
  output: z.null(),
};
